import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

interface ModernHeroSectionProps {
  className?: string;
}

const ModernHeroSection = ({ className }: ModernHeroSectionProps) => {
  return (
    <section
      className={`pt-32 pb-20 px-4 bg-gradient-to-br from-indigo-50 via-purple-50 to-white dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 ${className}`}
    >
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="lg:w-1/2 space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white leading-tight">
              <span className="text-nation-purple">NationCard™</span> Cayman
              Islands is Now Live
            </h1>
            <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
              Join the platform that's keeping democracy alive between
              elections. Experience transparency, engagement, and accountability
              in local governance.
            </p>
            <div className="pt-4 flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-nation-purple hover:bg-nation-purple-dark shadow-lg hover:shadow-xl transition-all"
                asChild
              >
                <Link to="/cards/KY" className="flex items-center gap-2">
                  Access NationCard™ Platform{" "}
                  <ArrowRight className="h-5 w-5" />
                </Link>
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-nation-purple text-nation-purple hover:bg-nation-purple/10"
                asChild
              >
                <Link to="/civic-education">Learn More</Link>
              </Button>
            </div>
          </div>
          <div className="lg:w-1/2 mt-8 lg:mt-0 relative">
            <div className="absolute inset-0 bg-gradient-to-br from-nation-purple/20 to-transparent rounded-lg -z-10"></div>
            <img
              src="/img/nationcard-hero5.png"
              alt="NationCard™ Platform"
              className="rounded-lg shadow-xl w-full h-auto object-cover transform hover:scale-[1.02] transition-transform duration-500"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernHeroSection;
